import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import ToggledRow from './ToggledRow';
import { useMediaQuery } from 'react-responsive/src';
import Title from './table/Title';
import TableCellText from './TableCellText';
import { Button } from 'react-bootstrap';
import ConfirmAlert from './ConfirmAlert';
import { useDispatch, useSelector } from 'react-redux';
import {
  organizationMembershipAdminDelete,
  organizationMembershipCourseCreatorDelete,
} from '../app/store/action/organizationMembership';
import { instructor } from '../app/store/reducer/instructor';
import { instructorConnectionDelete } from '../app/store/action/organization';
import { getCourseCreateActionButton } from '../utils/PermissionManager';
import { INSTRUCTOR_CONNECTION } from '../app/store/reducer/organization';

export default function OrganizationMembershipList(props) {
  let { organizationMembershipList, title, count, currentPage, pageParamName, onPageChange, type } = props;

  let [showCols, setShowCols] = useState({
    name: true,
    organization: false,
    role: false,
    actions: false,
    more: true,
  });

  let [columns, setColumns] = useState([]);

  let allColumns = [
    {
      Header: 'نام و نام خانوادگی',
      accessor: 'name',
      colName: 'name',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={`${row.original.user.first_name} ${row.original.user.last_name}`} />,
    },
    {
      Header: 'نام سازمان',
      accessor: 'organization',
      colName: 'organization',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={row.original.organization.name} />,
    },
    {
      Header: 'نقش',
      accessor: 'role',
      colName: 'role',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={MEMBERSHIP_TYPES[row.original.role]} />,
    },
    {
      Header: 'فعالیت',
      accessor: 'actions',
      colName: 'actions',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={<CancelRequestBtn id={row.original.id} type={type} />} />,
    },
    {
      Header: '',
      accessor: 'more',
      colName: 'more',
      disableFilters: true,
      Cell: ({ row }) => (
        <div {...row.getToggleRowExpandedProps()}>
          <TableCellText text={<span className={'font-weight-bold'}>بیشتر...</span>} />
        </div>
      ),
    },
  ];

  let isMDScreen = useMediaQuery({ query: '(min-width: 768px)' });
  let isXLScreen = useMediaQuery({ query: '(min-width: 1200px)' });

  // Toggled row to parents (used in mobile and tablet version)
  function toggledRow(row, visibleCols) {
    let fullRowValues = {
      ...row.original,
      name: `${row.original.user.first_name} ${row.original.user.last_name}`,
      organization: row.original.organization.name,
      role: MEMBERSHIP_TYPES[row.original.role],
    };

    let items = {
      ...(!visibleCols.name && { name: 'نام و نام خانوادگی' }),
      ...(!visibleCols.organization && { organization: 'نام سازمان' }),
      ...(!visibleCols.role && { role: 'نقش' }),
      ...(!visibleCols.actions && { actions: 'فعالیت' }),
    };
    return (
      <Fragment>
        <ToggledRow rowValues={fullRowValues} items={items} />
      </Fragment>
    );
  }

  function fetchData() {}

  // toggle show property in toggleCols state
  function handleToggleCols(objShowCols, showCols, hideCols = []) {
    let newObjShowCols = { ...objShowCols };
    Object.keys(objShowCols).forEach(item => {
      if (showCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: true };
      if (hideCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: false };
    });

    return newObjShowCols;
  }

  useEffect(() => {
    let newToggleCols = { ...showCols };

    // toggle cols => more, group_name, phone_number
    let xsShowCols = ['more'];
    let xsHideCols = ['organization', 'role', 'actions'];

    let mdShowCols = ['actions', 'more'];
    let mdHideCols = ['organization', 'role'];

    let xlShowCols = ['organization', 'role', 'actions'];
    let xlHideCols = ['more'];

    if (isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, xlShowCols, xlHideCols);
    else if (!isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, mdShowCols, mdHideCols);
    else newToggleCols = handleToggleCols(newToggleCols, xsShowCols, xsHideCols);

    setShowCols(newToggleCols);
  }, [isMDScreen, isXLScreen]);

  useEffect(() => {
    let newColumns = allColumns.filter(item => showCols[item.colName]);

    setColumns(newColumns);
    /* eslint-disable-next-line */
  }, [showCols]);

  return (
    <Fragment>
      <Title value={title} />
      <Table
        data={organizationMembershipList.data}
        /* eslint-disable-next-line */
        columns={useMemo(() => columns)}
        hasPagination={false}
        fetchData={fetchData}
        loading={organizationMembershipList.isLoading}
        count={count}
        toggledRow={toggledRow}
        showToggledRow={!isXLScreen}
        toggledRowProps={showCols}
        currentPage={currentPage}
        onPageChange={onPageChange}
        pageParamName={pageParamName}
      />
    </Fragment>
  );
}

function CancelRequestBtn(props) {
  let { id, type } = props;

  let [visibleConfirm, setVisibleConfirm] = useState(false);
  let [loading, setLoading] = useState(false);

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let detailOfOrganizationMembershipAdmin = useSelector(state => state.organizationMembership.admin);
  let detailOfOrganizationMembershipCourseCreator = useSelector(state => state.organizationMembership.courseCreator);
  let detailOfInstructorConnection = useSelector(state => state.organization.instructorConnection);

  let apiLoading = useSelector(state => state.organization.instructorConnection.loading);

  let dispatch = useDispatch();

  function handleConfirmClick() {
    if (type === 'admin') {
      dispatch(organizationMembershipAdminDelete(id));
    } else if (type === 'instructor') {
      dispatch(instructorConnectionDelete(id));
    } else {
      dispatch(organizationMembershipCourseCreatorDelete(id));
    }
    setLoading(true);

    setVisibleConfirm(false);
  }

  let handleCancelClick = b => setVisibleConfirm(b);

  useEffect(() => {
    let condition =
      !!detailOfOrganizationMembershipAdmin.data ||
      (!!detailOfOrganizationMembershipCourseCreator.data && !!detailOfInstructorConnection.data);
    if (condition) {
      setLoading(false);
      setVisibleConfirm(false);
    }
  }, [detailOfOrganizationMembershipAdmin.data, detailOfOrganizationMembershipCourseCreator.data]);

  useEffect(() => {
    setLoading(apiLoading);
  }, apiLoading);

  return (
    <Fragment>
      {getCourseCreateActionButton(selectedRole, handleCancelClick, type)}
      <ConfirmAlert
        onConfirm={handleConfirmClick}
        visible={visibleConfirm}
        title={'لغو درخواست'}
        onClose={() => handleCancelClick(false)}
        body={'آیا مطمئن هستید؟'}
        confirmLoading={loading}
      />
    </Fragment>
  );
}

OrganizationMembershipList.propTypes = {
  organizationMembershipList: PropTypes.shape({
    data: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  pageParamName: PropTypes.string,
  type: PropTypes.oneOf(['admin', 'courseCreator']),
};

CancelRequestBtn.propTypes = {
  id: PropTypes.number,
  type: PropTypes.oneOf(['admin', 'courseCreator']),
};

const MEMBERSHIP_TYPES = {
  course_creator: 'دوره ساز',
  admin: 'مدیر',
  instructor: 'استاد',
};
